import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { SelectItem, DataTable, Paginator } from "primeng/primeng";
import { PaginationComponent } from '../../pagination/pagination.component';
import { PaginationService } from '../../../core/pagination/paginator.service';
import { PaymentService } from '../../../core/payments/payments.service';
import { IPagin } from '../../../core/pagination/IPaginator-model';
import * as _ from 'lodash';
import {ModalDirective} from "ngx-bootstrap";
import Popper from 'popper.js';
import Tooltip from 'tooltip.js';
import { AuthService } from "../../../core/auth/auth.service";
import { AccountaymentModel, AwardTransactionsBeans } from '../../../core/payments/account-payment.model';
import { MessageService } from "primeng/components/common/messageservice";
declare var $;
@Component({
  //selector: 'pagos',
  templateUrl: 'payments.component.html',
  styleUrls: ['payments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentsComponent extends PaginationComponent implements OnInit, AfterViewInit {


  /*pagin: any = { page: 0, size: 4, path: 'people/get-all' }*/
  itemsSelected: AwardTransactionsBeans[] = [];
  actualPage: number = 0;
  comisionesAmount: number = 0;
  totalAmount: number = 0;
  tabIndex = 0;
  @ViewChild("dts")
  dt: DataTable


  private exportToolTip;


  constructor(private paginationService: PaginationService,
    private authService: AuthService,
    private messageService: MessageService,
    private paymentService: PaymentService) {
    super(messageService, paginationService);
    console.log('revisando constructor');
  }

  ngAfterViewInit() {
    //$('#export').tooltip();
    this.exportToolTip = new Tooltip($('#export'), {
      placement: 'button',
      title: 'Solo se descargaran los registros de la pagina actual',
      trigger: 'hover'
    });
  }

  ngOnInit() {
    this.data = { page: 0, size: 20, path: 'award/transactions' };
    //this.data2Find = { page: 0, size: 20, path: 'award/transactions' };
    //this.data2Find = { page: 0, size: 20, path: 'award/transactions' };
    /*this.authService.getCustomerByUsername()
      .subscribe()*/
    super.ngOnInit();
  }

  paginateByStatus(event){
    console.log('Mostramos la pagina',event);
    this.actualPage = event.page;
    if(event.index == 0){
      this.data = { page: 0, size: 20, path: 'award/transactions' };
      this.getPage(this.actualPage);
    } else if(this.tabIndex == 1){
      //this.data2Find = { page: event.page, size: event.rows, path: 'award/transactions/status' };
      this.data = { page: event.page, size: event.rows, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(event.page, 'in_progress');
    } else if(this.tabIndex == 2){
      this.data = { page: event.page, size: event.rows, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(event.page, 'failed');
    } else if(this.tabIndex == 3){
      this.data = { page: event.page, size: event.rows, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(event.page, 'completed');
    }
  }

  paginate(event) {
    this.data.size = event.rows;
    this.actualPage = event.page;
    this.getPage(this.actualPage);
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
  }

  /*getUser(){

      console.log('El usuario es:',this.authService.user);
  }*/

  handleChange(event){
    console.log('Mostramos el index',event.index);
    this.totalSize = 0;
    this.tabIndex = event.index;
    if(event.index == 0){
      this.data = { page: 0, size: 20, path: 'award/transactions' };
      this.getPage(0);
    } else if(event.index == 1){
      this.data = { page: 0, size: 20, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(this.actualPage, 'in_progress');
    } else if(event.index == 2){
      this.data = { page: 0, size: 20, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(this.actualPage, 'failed');
    } else if(event.index == 3){
      this.data = { page: 0, size: 20, path: 'award/transactions/status' };
      this.getPagePaymentsByStatusage(this.actualPage, 'completed');
    }
    
  }

  doPayout2Account() {
    console.log(this.fillModel());
    this.loading = true;
    this.paymentService.doPayout2Account(this.fillModel())
      .finally(() => {
        this.itemsSelected = [];
        this.getPage(this.actualPage);
      })
      .subscribe(response => {
        this.totalAmount = 0;
        this.comisionesAmount = 0;
        console.log('mostramos la respuesta: ', response);
        this.messageService.add({
            severity: 'success',
            summary: '',
            detail: 'Se realizo la peticion con exito'
          });
      },
      error => {

        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        console.error('mostramos el error: ', error);
      })
  }

  private fillModel(){
    //AccountaymentModel, AwardTransactionsBeans
    let model: AccountaymentModel = new AccountaymentModel();
    model.awardTransactionsBeans = this.itemsSelected;
    return model;
  }

  addReference(value){
    //this.itemsSelected = [value.data];
    /*if (value.data.account !== 'OK') {
         this.itemsSelected = _.remove(this.itemsSelected, item => {
        console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
        return item.wagerReferenceId == value.data.wagerReferenceId
      });
    } else {*/

      _.remove(this.itemsSelected, item => item.id.wagerReferenceIdKey === value.data.id.wagerReferenceIdKey);
      this.itemsSelected = _.concat(this.itemsSelected, value.data);
      this.getTotales();
    //}

  }

/*  cancelReference(value){
    _.remove(this.itemsSelected, item => {
        console.log(item.wagerReferenceId, value.data.wagerReferenceId, item.wagerReferenceId == value.data.wagerReferenceId)
        return item.wagerReferenceId == value.data.wagerReferenceId
      });
  }*/

  onRowSelect(event) {

    /*console.log(event);
    if (event.data.account !== 'OK') {
      //this.itemsSelected.splice(event.data, 1);
      let itemsTmp = this.itemsSelected;
      this.itemsSelected = [];
      _.remove(itemsTmp, item => {
        console.log(item.wagerReferenceId, event.data.wagerReferenceId, item.wagerReferenceId == event.data.wagerReferenceId)
        return item.wagerReferenceId == event.data.wagerReferenceId
      });


      this.itemsSelected = _.concat(this.itemsSelected, itemsTmp);
    }
    console.log(this.itemsSelected);*/
    this.getTotales();

  }

  onRowUnselect(event) {
    this.getTotales();
  }

  getTotales(){
    this.comisionesAmount = 0;
    this.totalAmount = 0;
    _.forEach(this.itemsSelected, item => {
      /*this.comisionesAmount += item.fee;
      this.totalAmount += item.total2Paid;*/
      this.comisionesAmount = parseFloat(this.comisionesAmount.toString()) + parseFloat(item.feeAmount);
      this.totalAmount = parseFloat(this.totalAmount.toString()) + parseFloat(item.transferAmount);
    });
  }

  display: boolean = false;
  showDialog() {
        this.display = true;
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/payments/phisical-account/payments.component.ts